import { render, staticRenderFns } from "./CertList.vue?vue&type=template&id=5e9873d2&scoped=true"
import script from "./CertList.vue?vue&type=script&lang=js"
export * from "./CertList.vue?vue&type=script&lang=js"
import style0 from "./CertList.vue?vue&type=style&index=0&id=5e9873d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9873d2",
  null
  
)

export default component.exports